import React from "react"
import LoaderGIF from '../assets/ManipalCigna-Loder.gif'
export function LoaderComponent(props) {
    return (
        <div className="main_loader">
            <img alt="loader" src={LoaderGIF} width="150" />
        </div>
    )
} 